import "@Cyclope/styles/app.scss";

import OriginalApp from '../original';

export default OriginalApp;
